import { takeEvery } from 'redux-saga/effects';

import * as paymentMethodsActionTypes from 'store/modules/paymentMethods/actionTypes';
import { setDefault } from './utils';

export default function* listenSetDefault() {
  yield takeEvery(paymentMethodsActionTypes.SET_DEFAULT, setDefault);
}
